import React, { useEffect, useCallback, useState } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CreateWizardConfigContextProvider } from './CreateWizardConfigContext';

import { HomePage, NewSurveyPage, TemplatesPage } from './pages';
import { DEFAULT_STYLES, DEFAULT_CREATE_WIZARD_CONFIG } from './DefaultCreateWizardConfig';

const CreateWizardRouter = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  const [createWizardConfig, setCreateWizardConfig] = useState(DEFAULT_CREATE_WIZARD_CONFIG);

  const updateCreateWizardConfig = newConfigs => {
    const configs = { ...newConfigs, style: { ...DEFAULT_STYLES, ...newConfigs.style } };
    setCreateWizardConfig(configs);
  };

  const onMessageReceivedFromIframe = useCallback(event => {
    if (
      event.data &&
      event.data.message &&
      typeof event.data.message !== 'object' &&
      event.data.source === 'create-wizard-app'
    ) {
      const data = JSON.parse(event.data.message);
      localStorage.setItem('createExperiencePayload', event.data.message);
      updateCreateWizardConfig(data);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', onMessageReceivedFromIframe);
    return () => window.removeEventListener('message', onMessageReceivedFromIframe);
  }, [onMessageReceivedFromIframe]);

  useEffect(() => {
    const payload = localStorage.getItem('createExperiencePayload');
    if (payload) {
      const data = JSON.parse(payload);
      updateCreateWizardConfig(data);
    }
  }, []);

  return (
    <CreateWizardConfigContextProvider createWizardConfig={createWizardConfig}>
      <Switch>
        <Route path="/createwizard/new-survey/:surveyTypeSelected" component={NewSurveyPage} />
        <Route path="/createwizard/templates" component={TemplatesPage} />
        <Route path="/createwizard" component={HomePage} />
      </Switch>
    </CreateWizardConfigContextProvider>
  );
};

CreateWizardRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(CreateWizardRouter);
